export const STORE_PAGINATION = 'STORE_PAGINATION';
export const CHANGE_PAGE = 'CHANGE_PAGE';
